import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { TemplateRequestManagerStyled } from './styled'
import { PageTitle } from '../../atoms'
import { Grid, Typography, TextField, Box } from '@material-ui/core'
import i18n from '../../../assets/i18n'
import moment from 'moment'
import routes from '../../../config/routes'
import BackButton from '../../atoms/back-button'
import SingleDate from '../../molecules/single-date-picker'
import Autocomplete from '@material-ui/lab/Autocomplete'
import RegularButton from '../../atoms/regular-button'
import { createTemplate } from '../../../api/index'
import { useMutation } from '@tanstack/react-query'
import InputField from '../../atoms/input-field'
import { useRequirements } from '../../../api/queries/useRequirements'
import { LIMITCANDIDATESNUMBER, ALERT_LEVEL } from '../../../config/constants'
import { isAlsea } from '../../../utils/clientHelpers'

import { useAppContext } from '../../../context/appContext'
import { useLocation } from 'react-router-dom'

let vacanciesOptions = new Array(10).fill(0).map((_, index) => ({ id: index + 1, name: `${index + 1}` }))

const ProcessCreateTemplateRequestManager = ({ isSupervisorView, user, client }) => {
  const { createAlert } = useAppContext();
  const location = useLocation();
  const history = useHistory();

  // Soportar ambos tipos de state: array (flujo antiguo) u objeto (flujo nuevo)
  let state = location.state;
  if (!state) state = {};
  // Si el state es objeto y tiene rowSelected (flujo nuevo), usar ese array como legacyState
  let legacyState;
  if (Array.isArray(state)) {
    legacyState = state[0];
  } else if (Array.isArray(state.rowSelected)) {
    legacyState = state.rowSelected[0];
  } else {
    legacyState = undefined;
  }
  const parentId = Array.isArray(state) ? undefined : state.parentId;
  const isCloneLinked = Array.isArray(state) ? false : state.isCloneLinked === true;
 
  const VACANCY_STATES = {
    CANCELLED: 'cancelled',
    REJECTED: 'rejected',
    ACTIVE: 'active',
    CLOSED: 'closed',
    PENDING: 'pending',
    EMPTY: 'empty'
  }

  const isAlseaClient = isAlsea()

  if (isAlseaClient) { 
    vacanciesOptions = new Array(3).fill(0).map((_, index) => ({ id: index + 1, name: `${index + 1}` }))
  }

  let typeContractOptions = [
    { id: 1, name: i18n.templateRequestManager.typeContractIndefinite },
    { id: 2, name: i18n.templateRequestManager.typeContractTemporary },
    { id: 3, name: i18n.templateRequestManager.typeContractInterim }
  ]

  const WORKING_DAY = {
    FULL_TIME: 'full_time',
    PART_TIME: 'part_time',
    WEEKEND: 'weekend',
  }

  let workingDayOptions = [
    { id: WORKING_DAY.FULL_TIME, name: i18n.templateRequestManager.workingDay.full_time },
    { id: WORKING_DAY.PART_TIME, name: i18n.templateRequestManager.workingDay.part_time },
    { id: WORKING_DAY.WEEKEND, name: i18n.templateRequestManager.workingDay.weekend },
  ]

  const WORK_SHIFT = {
    MORNING: 'morning_shift',
    NIGHT: 'night_shift',
    SWING: 'swing_shift',
    SPLIT: 'split_shift',
    FULL: 'full_shift',
  }

  let workShiftOptions = [
    { id: WORK_SHIFT.MORNING, name: i18n.templateRequestManager.workShift.morning_shift },
    { id: WORK_SHIFT.SWING, name: i18n.templateRequestManager.workShift.swing_shift },
    { id: WORK_SHIFT.NIGHT, name: i18n.templateRequestManager.workShift.night_shift },
    { id: WORK_SHIFT.SPLIT, name: i18n.templateRequestManager.workShift.split_shift },
    { id: WORK_SHIFT.FULL, name: i18n.templateRequestManager.workShift.full_shift },
  ]

  let contractHoursOptions = [
    { id: '40', name: i18n.templateRequestManager.contractHours['40'] },
    { id: '39', name: i18n.templateRequestManager.contractHours['39'] },
    { id: '38', name: i18n.templateRequestManager.contractHours['38'] },
    { id: '37', name: i18n.templateRequestManager.contractHours['37'] },
    { id: '36', name: i18n.templateRequestManager.contractHours['36'] },
    { id: '35', name: i18n.templateRequestManager.contractHours['35'] },
    { id: '34', name: i18n.templateRequestManager.contractHours['34'] },
    { id: '33', name: i18n.templateRequestManager.contractHours['33'] },
    { id: '32', name: i18n.templateRequestManager.contractHours['32'] },
    { id: '31', name: i18n.templateRequestManager.contractHours['31'] },
    { id: '30', name: i18n.templateRequestManager.contractHours['30'] },
    { id: '29', name: i18n.templateRequestManager.contractHours['29'] },
    { id: '28', name: i18n.templateRequestManager.contractHours['28'] },
    { id: '27', name: i18n.templateRequestManager.contractHours['27'] },
    { id: '26', name: i18n.templateRequestManager.contractHours['26'] },
    { id: '25', name: i18n.templateRequestManager.contractHours['25'] },
    { id: '24', name: i18n.templateRequestManager.contractHours['24'] },
    { id: '23', name: i18n.templateRequestManager.contractHours['23'] },
    { id: '22', name: i18n.templateRequestManager.contractHours['22'] },
    { id: '21', name: i18n.templateRequestManager.contractHours['21'] },
    { id: '20', name: i18n.templateRequestManager.contractHours['20'] },
    { id: '19', name: i18n.templateRequestManager.contractHours['19'] },
    { id: '18', name: i18n.templateRequestManager.contractHours['18'] },
    { id: '17', name: i18n.templateRequestManager.contractHours['17'] },
    { id: '16', name: i18n.templateRequestManager.contractHours['16'] },
    { id: '15', name: i18n.templateRequestManager.contractHours['15'] },
    { id: '14', name: i18n.templateRequestManager.contractHours['14'] },
    { id: '13', name: i18n.templateRequestManager.contractHours['13'] },
    { id: '12', name: i18n.templateRequestManager.contractHours['12'] },
    { id: '11', name: i18n.templateRequestManager.contractHours['11'] },
    { id: '10', name: i18n.templateRequestManager.contractHours['10'] },
    { id: '8', name: i18n.templateRequestManager.contractHours['8'] },
  ]

  let statusOptions = [
    { id: VACANCY_STATES.CANCELLED, value: i18n.templateRequestManager.vacancyStates[VACANCY_STATES.CANCELLED] },
    { id: VACANCY_STATES.REJECTED, value: i18n.templateRequestManager.vacancyStates[VACANCY_STATES.REJECTED] },
    { id: VACANCY_STATES.ACTIVE, value: i18n.templateRequestManager.vacancyStates[VACANCY_STATES.ACTIVE] },
    { id: VACANCY_STATES.CLOSED, value: i18n.templateRequestManager.vacancyStates[VACANCY_STATES.CLOSED] },
    { id: VACANCY_STATES.PENDING, value: i18n.templateRequestManager.vacancyStates[VACANCY_STATES.PENDING] },
    { id: VACANCY_STATES.EMPTY, value: i18n.templateRequestManager.vacancyStates[VACANCY_STATES.EMPTY] }
  ]

  const VACANCY_REASONS = {
    GAP: 'gap',
    REPLACEMENT: 'replacement',
  }

  let reasonOptions = [
    { id: VACANCY_REASONS.GAP, value: i18n.templateRequestManager.vacancyReasons[VACANCY_REASONS.GAP] },
    { id: VACANCY_REASONS.REPLACEMENT, value: i18n.templateRequestManager.vacancyReasons[VACANCY_REASONS.REPLACEMENT] },
  ]

  const [focusedDateIncop, setFocusedDateIncop] = useState(null)
  const [positionOptions, setPositionOptions] = useState([])
  const [allPositionOptions, setAllPositionOptions] = useState([])
  const [workplaceOptions, setWorkplaceOptions] = useState([])
  const [isAllFieldsFilled, setIsAllFieldsFilled] = useState(false)
  const [requirementsRequiredOptions, setRequirementsRequiredOptions] = useState([])
  const [requirementsDesirableOptions, setRequirementsDesirableOptions] = useState([])
  const [isSaving, setIsSaving] = useState(false)

  const initialState = {
    constraints: [],
    scoring_fields: [],
    dateIncorporation: legacyState?.start_date_at ? moment(legacyState.start_date_at) : moment().add(7, 'days'),
    position:
      legacyState?.filters?.constraints?.candidature_id
        ? { id: legacyState.filters.constraints.candidature_id, name: legacyState.candidature_settings?.name }
        : '',
    statusProcess: legacyState?.state ? statusOptions.find(status => status.id === legacyState.state).value : i18n.templateRequestManager.vacancyStates[VACANCY_STATES.PENDING],
    reason: legacyState?.reason ? reasonOptions.find(reason => reason.id === legacyState.reason) : null,
    typeContract:
      legacyState?.information?.contract_type ? { id: legacyState.information.contract_type, name: legacyState.information.temporary_contract } : '',
      workingDay:
    legacyState?.working_day
    ? workingDayOptions.find(opt => opt.id === legacyState.working_day) || { id: legacyState.working_day, name: legacyState.working_day }
    : '',
    workShift:
    legacyState?.work_shift
      ? workShiftOptions.find(opt => opt.id === legacyState.work_shift) || { id: legacyState.work_shift, name: legacyState.work_shift }
      : '',
    contractHours:
      legacyState?.contract_hours ? { id: legacyState.contract_hours, name: legacyState.contract_hours } : '',
    workplace: legacyState?.client_place?.id ? { id: legacyState.client_place.id, name: legacyState.client_place.name } : '',
    filters: {
      constraints: {},
      scoring_fields: {}
    },
    information: {
      observations: legacyState?.information?.observations ? legacyState.information.observations : ''
    },
    limit_candidates: '',
    vacancies: legacyState?.vacancies ? { id: legacyState.vacancies, name: String(legacyState.vacancies) } : { id: 1, name: '1' }
  }

  const filtrarOptionsRequirements = obj => {
    let resultado = []
    for (let propiedad in obj) {
      if (typeof obj[propiedad] === 'string' && propiedad !== 'unidad' && propiedad !== 'candidatura_id') {
        resultado.push({ id: propiedad, name: obj[propiedad] })
      }
    }
    return resultado
  }

  const filterRequirements = newValues => {
    const updatedRequirementsRequiredOptions = requirementsRequiredOptions.filter(
      option => !newValues.some(newValue => newValue.id === option.id && newValue.name === option.name)
    )
    const updatedRequirementsRequiredOptionsOrder = sortArrayByField('name', updatedRequirementsRequiredOptions)
    setRequirementsRequiredOptions(updatedRequirementsRequiredOptionsOrder)

    const updatedRequirementsDesirableOptions = requirementsDesirableOptions.filter(
      option => !newValues.some(newValue => newValue.id === option.id && newValue.name === option.name)
    )
    const updatedRequirementsDesirableOptionsOrder = sortArrayByField('name', updatedRequirementsDesirableOptions)
    setRequirementsDesirableOptions(updatedRequirementsDesirableOptionsOrder)
  }

  const [formData, setFormData] = useState(initialState)

  const { data: requirementsData, refetch, isLoading } = useRequirements(formData.position.id, formData.position !== '')
  useEffect(() => {
    const candidatureConfigs = user.candidature_configs.length ? user.candidature_configs : client.candidature_configs
    
    const optionsPositions = candidatureConfigs.map(config => ({ 
      id: config.id, 
      name: config.name,
      client_brand: config.client_brand
    }))
    const staff = user.staffs

    let resultOptionsWorkplace = []
    staff.map(place =>
      place.client_places.forEach(clientPlace => {
        resultOptionsWorkplace.push({
          id: clientPlace.id,
          name: clientPlace.name,
          brand: clientPlace.brand,
          is_franchise: clientPlace.is_franchise
        })
      })
    )

    const positionOrder = sortArrayByField('name', optionsPositions)
    const clientPlaces = resultOptionsWorkplace.length ? resultOptionsWorkplace : client.client_places ?? []

    setAllPositionOptions(positionOrder)
    setPositionOptions(positionOrder)
    setWorkplaceOptions(clientPlaces)
  }, [])

  useEffect(() => {
    if (requirementsData) {
      const combinedOptions = requirementsData.map(item => ({
        id: item.question_remote_name,
        name: `${item.question_name} - ${item.answer_value}`
      }))

      const requirementsOrder = sortArrayByField('name', combinedOptions)

      setRequirementsRequiredOptions(requirementsOrder)
      setRequirementsDesirableOptions(requirementsOrder)
    }

    // Solo si legacyState existe (es clonación), actualizar formData
    if (legacyState && requirementsData) {
      const dataRequirementsConstraints = filtrarOptionsRequirements(legacyState?.filters?.constraints)
      const filteredResultsConstraints = requirementsData
        ?.filter(item2 => dataRequirementsConstraints.some(item1 => item2.question_remote_name === item1.id && item2.answer_value === item1.name))
        .map(element => {
          return {
            id: element.question_remote_name,
            name: `${element.question_name} - ${element.answer_value}`
          }
        })

      const dataRequirementsScoringFields = filtrarOptionsRequirements(legacyState?.filters?.scoring_fields)
      const filteredResultsScoringFields = requirementsData
        ?.filter(item2 => dataRequirementsScoringFields.some(item1 => item2.question_remote_name === item1.id && item2.answer_value === item1.name))
        .map(element => {
          return {
            id: element.question_remote_name,
            name: `${element.question_name} - ${element.answer_value}`
          }
        })

      setFormData({ ...formData, constraints: filteredResultsConstraints, scoring_fields: filteredResultsScoringFields })
    }
  }, [formData.position, requirementsData])

  useEffect(() => {
    // Solo si legacyState existe (es clonación), actualizar formData.position
    if (legacyState) {
      setFormData(prevState => ({
        ...prevState,
        position: { id: legacyState?.filters?.constraints?.candidatura_id, name: legacyState?.candidature_settings?.name }
      }))
    }
  }, [legacyState])

  const sortArrayByField = (field, array, ascending = true) => {
    return array.slice().sort((a, b) => {
      if (a[field] < b[field]) {
        return ascending ? -1 : 1
      }
      if (a[field] > b[field]) {
        return ascending ? 1 : -1
      }
      return 0
    })
  }

  const createProcess = async data => {
    try {
      await createTemplate(data)
    } catch (error) {
      console.error('Error while creating process:', error)
      throw error
    }
  }

  const mutationCreateProcess = useMutation(createProcess, {
    onSuccess: () => {
      createAlert(i18n.templateRequestManager.processCreatedSuccessfully, ALERT_LEVEL.SUCCESS)
      setTimeout(() => {
        history.push(routes.templateRequestManager)
      }, 1000)
    },
    onError: () => {
      createAlert(i18n.templateRequestManager.errorCreatingProcess, ALERT_LEVEL.ERROR)
    }
  })

  const handleChangePosition = (_, newValue) => {
    setFormData({ ...formData, scoring_fields: [], constraints: [], position: newValue })
    refetch()
  }

  const handleChangeStatus = (_, newValue) => {
    setFormData({ ...formData, statusProcess: newValue })
  }

  const handleChangeTypeContract = (_, newValue) => {
    setFormData({ ...formData, typeContract: newValue })
  }

  const handleChangeWorkingDay = (_, newValue) => {
    setFormData({ ...formData, workingDay: newValue })
  }

  const handleChangeWorkShift = (_, newValue) => {
    setFormData({ ...formData, workShift: newValue })
  }

  const handleChangeContractHours = (_, newValue) => {
    setFormData({ ...formData, contractHours: newValue })
  }

  const handleChangeWorkplace = (_, newValue) => {
    setFormData({ ...formData, workplace: newValue, position: '' })
    
    // Solo para clientes de Alsea con franquicia: Filtrar posiciones por marca del workplace seleccionado
    if (isAlseaClient && newValue?.is_franchise) {
      if (newValue && newValue.brand) {
        const filteredPositions = allPositionOptions.filter(pos => {
          // Mostrar posiciones sin marca (client_brand undefined/null) o que coincidan con la marca del workplace
          return !pos.client_brand || pos.client_brand?.id === newValue.brand.id
        })
        setPositionOptions(filteredPositions)
      } else {
        // Si no hay workplace seleccionado o no tiene marca, mostrar todas
        setPositionOptions(allPositionOptions)
      }
    } else {
      // Para otros clientes o workplaces que no son franquicia, siempre mostrar todas las posiciones
      setPositionOptions(allPositionOptions)
    }
  }

  const addRequirementScoringFields = newValues => {
    const updatedRequirementsRequiredOptions = [...requirementsRequiredOptions, newValues]
    const updatedRequirementsRequiredOptionsOrder = sortArrayByField('name', updatedRequirementsRequiredOptions)
    setRequirementsRequiredOptions(updatedRequirementsRequiredOptionsOrder)

    const updatedRequirementsDesirableOptions = [...requirementsDesirableOptions, newValues]
    const updatedRequirementsDesirableOptionsOrder = sortArrayByField('name', updatedRequirementsDesirableOptions)
    setRequirementsDesirableOptions(updatedRequirementsDesirableOptionsOrder)

    setFormData(prevState => {
      const newScoringFields = prevState.scoring_fields.filter(scoringField => scoringField.id !== newValues.id || scoringField.name !== newValues.name)
      return {
        ...prevState,
        scoring_fields: newScoringFields
      }
    })
  }

  const addRequirementConstraints = newValues => {
    const updatedRequirementsRequiredOptions = [...requirementsRequiredOptions, newValues]
    const updatedRequirementsRequiredOptionsOrder = sortArrayByField('name', updatedRequirementsRequiredOptions)
    setRequirementsRequiredOptions(updatedRequirementsRequiredOptionsOrder)

    const updatedRequirementsDesirableOptions = [...requirementsDesirableOptions, newValues]
    const updatedRequirementsDesirableOptionsOrder = sortArrayByField('name', updatedRequirementsDesirableOptions)
    setRequirementsDesirableOptions(updatedRequirementsDesirableOptionsOrder)

    setFormData(prevState => {
      const newConstraints = prevState.constraints.filter(constraint => constraint.id !== newValues.id || constraint.name !== newValues.name)
      return {
        ...prevState,
        constraints: newConstraints
      }
    })
  }

  const handleChangeRequirementsRequired = (_, newValues) => {
    const previousValue = formData.constraints

    if (previousValue.length > newValues.length) {
      const removedItem = previousValue.find(item => !newValues.includes(item))
      addRequirementConstraints(removedItem)
    } else {
      setFormData(prevState => {
        filterRequirements(newValues)

        const newConstraints = newValues.map(({ id, name }) => ({ id, name }))

        return {
          ...prevState,
          constraints: newConstraints
        }
      })
    }
  }

  const handleChangeRequirementsDesirable = (_, newValues) => {
    const previousValue = formData.scoring_fields

    if (previousValue.length > newValues.length) {
      const removedItem = previousValue.find(item => !newValues.includes(item))
      addRequirementScoringFields(removedItem)
    } else {
      setFormData(prevState => {
        filterRequirements(newValues)

        const newScoringFields = newValues.map(({ id, name }) => ({ id, name }))

        return {
          ...prevState,
          scoring_fields: newScoringFields
        }
      })
    }
  }

  const handleTextareaObservations = event => {
    const newText = event.target.value
    setFormData({
      ...formData,
      information: {
        observations: newText
      }
    })
  }

  const handleChangeVacancies = (_, newValue) => {
    setFormData({ ...formData, vacancies: newValue })
  }

  const handleChangeReason = (_, newValue) => {
    setFormData({ ...formData, reason: newValue })
  }

  const formatConstraints = constraints => {
    const formattedConstraints = {}
    constraints.forEach(constraint => {
      const nameFormatted = constraint.name.split(' - ')[1]
      formattedConstraints[constraint.id] = nameFormatted
    })
    return formattedConstraints
  }

  const handleCreateProcess = e => {
    e.preventDefault()

    if (isSaving) return

    if (
      !formData.dateIncorporation ||
      !formData.position ||
      !formData.statusProcess ||
      !formData.typeContract ||
      !formData.workplace ||
      !formData.workingDay ||
      !formData.workShift ||
      !formData.contractHours ||
      !formData.reason
    ) {
      createAlert(i18n.templateRequestManager.emptyForm, ALERT_LEVEL.ERROR)
      return
    }

    setIsSaving(true)

    const formattedConstraints = formatConstraints(formData.constraints)
    const formattedScoringFields = formatConstraints(formData.scoring_fields)

    const dataToSend = {
      contract_type: parseInt(formData.typeContract.id),
      start_date_at: formData.dateIncorporation.format('YYYY-MM-DD'),
      limit_candidates: formData.vacancies.id * LIMITCANDIDATESNUMBER,
      vacancies: formData.vacancies.id,
      information: {
        contract_type: String(formData.typeContract.id),
        temporary_contract: formData.typeContract.name,
        observations: formData.information.observations
      },
      filters: {
        constraints: {
          unidad: String(formData.workplace.id),
          candidatura_id: formData.position.id,
          ...formattedConstraints
        },
        scoring_fields: {
          ...formattedScoringFields
        }
      },
      state: formData.statusProcess.id,
      reason: formData.reason.id ?? null,
      working_day: formData.workingDay.id ?? null,
      work_shift: formData.workShift.id ?? null,
      contract_hours: formData.contractHours.id ?? null,
      ...(parentId ? { parent_vacancy_request_id: parentId } : {})
    }

    mutationCreateProcess.mutate(dataToSend)
  }

  useEffect(() => {
    const areAllFieldsFilled = () => {
      return (
        formData.dateIncorporation &&
        formData.position &&
        formData.statusProcess &&
        formData.typeContract &&
        formData.workplace &&
        formData.workingDay &&
        formData.workShift &&
        formData.contractHours &&
        formData.reason
      )
    }

    setIsAllFieldsFilled(areAllFieldsFilled())
  }, [
    formData.dateIncorporation,
    formData.position,
    formData.statusProcess,
    formData.typeContract,
    formData.workplace,
    formData.workingDay,
    formData.workShift,
    formData.contractHours,
    formData.reason
  ])

  return (
    <TemplateRequestManagerStyled>
      <Grid container className="title-container">
        <Grid item sm={12}>
          <BackButton
            title={i18n.templateRequestManager.backToTemplateRequestManager}
            onClick={() => {
              history.push(routes.templateRequestManager)
            }}
          />
        </Grid>
      </Grid>

      <Grid container className="create-process-container">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box display="flex" flexDirection="column" gridGap={8}>
                    <PageTitle styles={{ fontSize: 18 }} title={i18n.templateRequestManager.newProcess} />
                    <Typography className="description">{i18n.templateRequestManager.descriptionNewProcess}</Typography>
                  </Box>
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box display="flex" flexDirection="column" className="form-card">
                    <h2 className="form-card-title">{i18n.templateRequestManager.sectionGeneral}</h2>
                    <Grid container spacing={3} className="group-input">
                      <Grid item xs={12} md={6} lg={3}>
                        <Box display="flex" flexDirection="column" gridGap={5}>
                          <label className="required">{i18n.templateRequestManager.dateIncorporation}</label>
                          <SingleDate
                            date={formData.dateIncorporation}
                            onDateChange={date => setFormData({ ...formData, dateIncorporation: date })}
                            focused={focusedDateIncop}
                            onFocusChange={({ focused }) => setFocusedDateIncop(focused)}
                            isFetching={false}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <Box display="flex" flexDirection="column" gridGap={5}>
                          <label className="required">{i18n.templateRequestManager.reason}</label>
                          <Autocomplete
                            size="small"
                            className="autocomplete-custom"
                            value={formData.reason}
                            options={reasonOptions}
                            getOptionLabel={option => option.value || ''}
                            renderInput={params => <TextField {...params} variant="outlined" />}
                            disableClearable={true}
                            onChange={(event, newValue) => handleChangeReason(event, newValue)}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <Box display="flex" flexDirection="column" gridGap={5}>
                          <label className="required">{i18n.templateRequestManager.numberVacancies}</label>
                          <Autocomplete
                            size="small"
                            className="autocomplete-custom"
                            value={formData.vacancies}
                            options={vacanciesOptions}
                            getOptionLabel={option => option.name || ''}
                            renderInput={params => <TextField {...params} variant="outlined" />}
                            disableClearable={true}
                            onChange={(event, newValue) => handleChangeVacancies(event, newValue)}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <Box display="flex" flexDirection="column" gridGap={5}>
                          {isAlseaClient ? (
                            <>
                              <label className="required">{i18n.templateRequestManager.workplace}</label>
                              <Autocomplete
                                size="small"
                                className="autocomplete-custom"
                                value={formData.workplace}
                                options={workplaceOptions}
                                getOptionLabel={option => option.name || ''}
                                renderInput={params => <TextField {...params} placeholder={i18n.templateRequestManager.placeholderWorkplace} variant="outlined" />}
                                disableClearable={true}
                                onChange={(event, newValue) => handleChangeWorkplace(event, newValue)}
                                disabled={isCloneLinked}
                              />
                            </>
                          ) : (
                            <>
                              <label className="required">{i18n.templateRequestManager.position}</label>
                              <Autocomplete
                                size="small"
                                className="autocomplete-custom"
                                value={formData.position}
                                options={positionOptions}
                                getOptionLabel={option => option.name || ''}
                                renderInput={params => <TextField {...params} placeholder={i18n.templateRequestManager.placeholderPosition} variant="outlined" />}
                                disableClearable={true}
                                onChange={(event, newValue) => handleChangePosition(event, newValue)}
                                disabled={isCloneLinked}
                              />
                            </>
                          )}
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <Box display="flex" flexDirection="column" gridGap={5}>
                          <label className="required">{i18n.templateRequestManager.statusProcess}</label>
                          <InputField
                            placeholder={i18n.templateRequestManager.placeholderStatusProcess}
                            value={formData.statusProcess}
                            onChange={(event, newValue) => handleChangeStatus(event, newValue)}
                            disabled={!isSupervisorView}
                          />
                        </Box>
                      </Grid>
                      {parentId && (
                        <Grid item xs={12} md={6} lg={3}>
                          <Box display="flex" flexDirection="column" gridGap={5}>
                            <label >{i18n.templateRequestManager.associateVacancy}</label>
                            <InputField value={parentId} disabled  />
                          </Box>
                        </Grid>
                        )}
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box display="flex" flexDirection="column" className="form-card">
                    <h2 className="form-card-title">{i18n.templateRequestManager.sectionContract}</h2>
                    <Grid container spacing={3} className="group-input">

                      <Grid item xs={12} md={6} lg={3}>
                        <Box display="flex" flexDirection="column" gridGap={5}>
                          <label className="required">{i18n.templateRequestManager.typeContract}</label>
                          <Autocomplete
                            size="small"
                            className="autocomplete-custom"
                            value={formData.typeContract}
                            options={typeContractOptions}
                            getOptionLabel={option => option.name || ''}
                            renderInput={params => (
                              <TextField {...params} placeholder={i18n.templateRequestManager.placeholderTypeContract} variant="outlined" />
                            )}
                            disableClearable={true}
                            onChange={(event, newValue) => handleChangeTypeContract(event, newValue)}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <Box display="flex" flexDirection="column" gridGap={5}>
                          <label className="required">{i18n.templateRequestManager.workingDayLabel}</label>
                          <Autocomplete
                            size="small"
                            className="autocomplete-custom"
                            value={formData.workingDay}
                            options={workingDayOptions}
                            getOptionLabel={option => option.name || ''}
                            renderInput={params => (
                              <TextField {...params} placeholder={i18n.templateRequestManager.placeholderWorkingDay} variant="outlined" />
                            )}
                            disableClearable={true}
                            onChange={(event, newValue) => handleChangeWorkingDay(event, newValue)}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <Box display="flex" flexDirection="column" gridGap={5}>
                          <label className="required">{i18n.templateRequestManager.workShiftLabel}</label>
                          <Autocomplete
                            size="small"
                            className="autocomplete-custom"
                            value={formData.workShift}
                            options={workShiftOptions}
                            getOptionLabel={option => option.name || ''}
                            renderInput={params => (
                              <TextField {...params} placeholder={i18n.templateRequestManager.placeholderWorkShift} variant="outlined" />
                            )}
                            disableClearable={true}
                            onChange={(event, newValue) => handleChangeWorkShift(event, newValue)}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <Box display="flex" flexDirection="column" gridGap={5}>
                          <label className="required">{i18n.templateRequestManager.contractHoursLabel}</label>
                          <Autocomplete
                            size="small"
                            className="autocomplete-custom"
                            value={formData.contractHours}
                            options={contractHoursOptions}
                            getOptionLabel={option => option.name || ''}
                            renderInput={params => (
                              <TextField {...params} placeholder={i18n.templateRequestManager.placeholderContractHours} variant="outlined" />
                            )}
                            disableClearable={true}
                            onChange={(event, newValue) => handleChangeContractHours(event, newValue)}
                          />
                        </Box>
                      </Grid>

                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box display="flex" flexDirection="column" className="form-card">
                    <h2 className="form-card-title">{i18n.templateRequestManager.sectionRequirements}</h2>
                    <Grid container spacing={3} className="group-input">

                      <Grid item xs={12} md={6} lg={3}>
                        <Box display="flex" flexDirection="column" gridGap={5}>
                          {isAlseaClient ? (
                            <>
                              <label className="required">{i18n.templateRequestManager.position}</label>
                              <Autocomplete
                                size="small"
                                className="autocomplete-custom"
                                value={formData.position}
                                options={positionOptions}
                                getOptionLabel={option => option.name || ''}
                                renderInput={params => <TextField {...params} placeholder={i18n.templateRequestManager.placeholderPosition} variant="outlined" />}
                                disableClearable={true}
                                onChange={(event, newValue) => handleChangePosition(event, newValue)}
                                disabled={isCloneLinked || !formData.workplace}
                              />
                            </>
                          ) : (
                            <>
                              <label className="required">{i18n.templateRequestManager.workplace}</label>
                              <Autocomplete
                                size="small"
                                className="autocomplete-custom"
                                value={formData.workplace}
                                options={workplaceOptions}
                                getOptionLabel={option => option.name || ''}
                                renderInput={params => <TextField {...params} placeholder={i18n.templateRequestManager.placeholderWorkplace} variant="outlined" />}
                                disableClearable={true}
                                onChange={(event, newValue) => handleChangeWorkplace(event, newValue)}
                                disabled={isCloneLinked}
                              />
                            </>
                          )}
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <Box display="flex" flexDirection="column" gridGap={5}>
                          <label>{i18n.templateRequestManager.mandatoryRequirements}</label>
                          <Autocomplete
                            multiple
                            size="small"
                            className="autocomplete-custom"
                            value={formData.constraints || []}
                            options={requirementsRequiredOptions}
                            getOptionLabel={option => option.name || ''}
                            renderInput={params => (
                              <TextField {...params} placeholder={i18n.templateRequestManager.placeholderRequirementsRequired} variant="outlined" />
                            )}
                            limitTags={2}
                            onChange={(event, newValue) => handleChangeRequirementsRequired(event, newValue)}
                            disabled={formData.position === '' || isLoading}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <Box display="flex" flexDirection="column" gridGap={5}>
                          <label>{i18n.templateRequestManager.desirableRequirements}</label>
                          <Autocomplete
                            multiple
                            size="small"
                            className="autocomplete-custom"
                            value={formData.scoring_fields || []}
                            options={requirementsDesirableOptions}
                            getOptionLabel={option => option.name || ''}
                            renderInput={params => (
                              <TextField {...params} placeholder={i18n.templateRequestManager.placeholderRequirementsDesirable} variant="outlined" />
                            )}
                            limitTags={2}
                            onChange={(event, newValue) => handleChangeRequirementsDesirable(event, newValue)}
                            disabled={formData.position === '' || isLoading}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box display="flex" flexDirection="column" className="form-card">
                    <Grid container spacing={3} className="group-input">
                      <Grid item xs={12}>
                        <Box display="flex" flexDirection="column" gridGap={5}>
                          <label>{i18n.templateRequestManager.observations}</label>
                          <textarea
                            className="textarea-question"
                            rows={2}
                            name="observations"
                            onChange={(event, newText) => handleTextareaObservations(event, newText)}
                            placeholder={i18n.templateRequestManager.placeholderObservations}
                            value={formData.information.observations}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box
                    item
                    display="flex"
                    justifyContent="flex-end"
                    className="container-item-vacancies"
                    mt={2}
                  >
                    <RegularButton
                      className="button-custom"
                      title={i18n.templateRequestManager.saveProcess}
                      onClick={handleCreateProcess}
                      disabled={!isAllFieldsFilled || isSaving}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </TemplateRequestManagerStyled>
  )
}

export default ProcessCreateTemplateRequestManager
